
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faqs/[slug]",
      function () {
        return require("private-next-pages/faqs/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faqs/[slug]"])
      });
    }
  